import React, { useEffect } from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
import { SmsVignette } from './showcase/SmsVignette';
const FORM_EMBED_SRC = 'https://api.viridiaanalytics.com/js/form_embed.js';
const callAgenda: string[] = ['We pull your response-time gaps across every lead source you pay for', 'You hear the live demo on your own script, in your own tone', 'You get the missed-lead math for your team whether you sign or not'];
export function Booking() {
  useEffect(() => {
    if (document.querySelector(`script[src="${FORM_EMBED_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = FORM_EMBED_SRC;
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <section id="book" aria-labelledby="book-title" className="scroll-mt-20 border-b border-white/5 bg-ink-900" data-id="element-19" data-mp="1aabh9cs47qpn">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 sm:py-24" data-id="element-20" data-mp="1f9emax83hwxm">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-21" data-mp="1qw8wctsvv82m">
          Missed-Lead Audit
        </p>
        <h1 id="book-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-22" data-mp="1mv5k0ha1nu65">
          Book your 15-minute Missed-Lead Audit.
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-23" data-mp="186shf1ggbd2o">
          We will pull your response-time gaps and show you the live demo on your own
          script. Worst case, you learn your team is airtight.
        </p>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1fr_360px] lg:items-start lg:gap-14" data-id="element-24" data-mp="1hxdo7c6a3nwo">
          <div data-id="element-25" data-mp="1d53rndanrplf">
            <h2 className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-26" data-mp="1d4aqcrugxsao">
              What happens on the call
            </h2>
            <ul className="mt-4 space-y-3" data-id="element-27" data-mp="khzu1tdwadjo">
              {callAgenda.map((item, index) => <li key={item} data-id="element-28" data-mp="2kjzajjgktqs6" data-mpi={index}>
                  <Reveal delay={0.06 * index} offset={10} className="flex items-start gap-3 text-sm leading-relaxed text-white/70" data-id="element-29" data-mp="2kiy11jf7lcck">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-30" data-mp="2ua2e2dlbqn4r" />
                    <span data-id="element-31" data-mp="21ln3q4d50szr">{item}</span>
                  </Reveal>
                </li>)}
            </ul>
          </div>

          <Reveal delay={0.1} className="w-full max-w-sm text-sm lg:max-w-none" data-id="element-32" data-mp="26jyc0ansavfv">
            <SmsVignette data-id="element-33" data-mp="2aki6f6gz3kyb" />
            <p className="mt-3 text-xs leading-relaxed text-white/40" data-id="element-34" data-mp="2ane8n6zusvsk">
              A 45 second reply on a portal lead. This is the behavior you will hear on
              your own script during the demo.
            </p>
          </Reveal>
        </div>

        <div className="mt-10 overflow-hidden rounded-xl border border-white/10 bg-white" data-id="element-35" data-mp="3qyi6chftjalk">
          <iframe src="https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ" style={{
          width: '100%',
          border: 'none',
          overflow: 'hidden',
          minHeight: '700px'
        }} scrolling="no" id="viridia-booking" title="Book your 15-minute Missed-Lead Audit" loading="eager" data-id="element-36" data-mp="4yc68pj4yq8y" />
        </div>
      </div>
    </section>;
}